import http from './http';

/**
 * 获取快捷键配置
 * @returns
 */
export const getShortcutConfig = () => {
  return http({
    method: 'get',
    url: '/shortcut/get',
  });
};

/**
 * 保存快捷键配置
 * @returns
 */
export const saveShortcutConfig = (data) => {
  return http({
    method: 'post',
    url: '/shortcut/save',
    data,
  });
};
